import { join } from 'path';

import { fetchGet } from '#providers/Fetch';
import makeHandler from '#services/makeHandler';

const URL = {
  getById: id => join('order', id),
  fetch  : 'orders',
};

const fetch = makeHandler(async query => fetchGet(
  URL.fetch, query
), { defaultError: 'Error fetching orders' });

const fetchStringQuery = makeHandler(async query => fetchGet(
  `${URL.fetch}?${query}`
), { defaultError: 'Error fetching orders' });

export default {
  fetch,
  fetchStringQuery,
};
